<template>
  <div>
    <!-- breadcrumb -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>系统参数</el-breadcrumb-item>
    </el-breadcrumb>

    <el-form ref="form" :model="editForm" :rules="rules" label-width="180px" class="margin-top">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>系统参数配置</span>
        </div>
        <el-form-item label="AI密钥" prop="aiApiKey">
          <div class="form-item-container">
            <el-input v-model="editForm.aiApiKey" placeholder="请输入AI API密钥" class="half-width" maxlength="128" show-password></el-input>
            <div class="check-result" v-if="checkResults.aiApiKey">
              <el-tag :type="checkResults.aiApiKey.valid ? 'success' : 'danger'">
                {{ checkResults.aiApiKey.message }}
              </el-tag>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="aiTextModel">
          <span slot="label">
            文本分析模型
            <a href="https://cloud.siliconflow.cn/me/models?tags=%E6%8E%A8%E7%90%86%E6%A8%A1%E5%9E%8B" target="_blank" class="label-link">
              <i class="el-icon-link"></i>
            </a>
          </span>
          <div class="form-item-container">
            <el-select v-model="editForm.aiTextModel" placeholder="请选择文本分析模型" class="half-width" :loading="modelsLoading" filterable>
              <el-option v-for="model in textModels" :key="model" :label="model" :value="model"></el-option>
            </el-select>
            <div class="check-result" v-if="checkResults.aiTextModel">
              <el-tag :type="checkResults.aiTextModel.valid ? 'success' : 'danger'">
                {{ checkResults.aiTextModel.message }}
              </el-tag>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="文本分析提示词" prop="aiTextUserPrompt">
          <div class="form-item-container">
            <el-input type="textarea" v-model="editForm.aiTextUserPrompt" placeholder="请输入文本分析用户提示词" :rows="6" class="half-width" show-word-limit></el-input>
            <div class="check-result" v-if="checkResults.aiTextUserPrompt">
              <el-tag :type="checkResults.aiTextUserPrompt.valid ? 'success' : 'danger'">
                {{ checkResults.aiTextUserPrompt.message }}
              </el-tag>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="aiImageModel">
          <span slot="label">
            视觉分析模型
            <a href="https://cloud.siliconflow.cn/me/models?tags=%E8%A7%86%E8%A7%89" target="_blank" class="label-link">
              <i class="el-icon-link"></i>
            </a>
          </span>
          <div class="form-item-container">
            <el-select v-model="editForm.aiImageModel" placeholder="请选择视觉分析模型" class="half-width" :loading="modelsLoading" filterable>
              <el-option v-for="model in vlModels" :key="model" :label="model" :value="model"></el-option>
            </el-select>
            <div class="check-result" v-if="checkResults.aiImageModel">
              <el-tag :type="checkResults.aiImageModel.valid ? 'success' : 'danger'">
                {{ checkResults.aiImageModel.message }}
              </el-tag>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="视觉分析提示词" prop="aiImageUserPrompt">
          <div class="form-item-container">
            <el-input type="textarea" v-model="editForm.aiImageUserPrompt" placeholder="请输入视觉分析用户提示词" :rows="6" class="half-width" show-word-limit></el-input>
            <div class="check-result" v-if="checkResults.aiImageUserPrompt">
              <el-tag :type="checkResults.aiImageUserPrompt.valid ? 'success' : 'danger'">
                {{ checkResults.aiImageUserPrompt.message }}
              </el-tag>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="关键词" prop="keyword">
          <div class="form-item-container">
            <el-input type="textarea" v-model="editForm.keyword" placeholder="请输入关键词，用英文逗号分隔，如：挖掘机,装载机,推土机" :rows="3" class="half-width" show-word-limit></el-input>
            <div class="check-result" v-if="checkResults.keyword">
              <el-tag :type="checkResults.keyword.valid ? 'success' : 'danger'">
                {{ checkResults.keyword.message }}
              </el-tag>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm">保存</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-card>
    </el-form>
  </div>
</template>

<script>
import { sysParamUpdate, sysParamGet, sysParamModels, sysParamCheck } from '../../api/sysParam'
import { loadToken } from '../../utils/util'
export default {
  data() {
    return {
      loading: false,
      checkLoading: false,
      modelsLoading: false,
      textModels: [],
      vlModels: [],
      checkResults: {},
      editForm: {
        id: 1,
        aiApiKey: '',
        aiTextModel: 'deepseek-chat',
        aiTextUserPrompt: '',
        aiImageModel: 'gpt-4o',
        aiImageUserPrompt: '',
        keyword: '',
        token: loadToken(),
      },
      userEntity: undefined,
      rules: {
        aiApiKey: [
          { required: true, message: '请输入AI密钥', trigger: 'blur' },
        ],
        aiTextModel: [
          { required: true, message: '请选择文本分析模型', trigger: 'change' },
        ],
        aiTextUserPrompt: [
          { required: true, message: '请输入文本分析提示词', trigger: 'blur' },
        ],
        aiImageModel: [
          { required: true, message: '请选择视觉分析模型', trigger: 'change' },
        ],
        aiImageUserPrompt: [
          { required: true, message: '请输入视觉分析提示词', trigger: 'blur' },
        ],
        keyword: [
          { required: true, message: '请输入关键词', trigger: 'blur' },
          { validator: (rule, value, callback) => {
            if (!value) {
              callback();
              return;
            }
            // 只允许中文字符和英文逗号
            const pattern = /^[\u4e00-\u9fa5]+(,[\u4e00-\u9fa5]+)*$/;
            if (!pattern.test(value)) {
              callback(new Error('关键词格式错误，请使用英文逗号分隔中文词组'));
            } else {
              callback();
            }
          }, trigger: 'blur' }
        ],
      },
    }
  },
  components: {
  },

  created() {
    // 加载用户缓存
    this.userEntity = JSON.parse(localStorage.getItem('userEntity'));
    // 加载系统参数配置
    this.getSysParamConfig();
    // 加载可用模型列表
    this.getModels();
  },
  methods: {
    // 获取系统参数配置
    getSysParamConfig() {
      this.loading = true;
      sysParamGet({}).then(res => {
        this.loading = false;
        if (res.success) {
          this.editForm = {
            ...res.data,
            token: loadToken()
          };
        } else {
          this.$message.error(res.message);
        }
      }).catch(err => {
        this.loading = false;
        this.$message.error('获取系统参数配置失败');
      });
    },
    // 提交表单
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          sysParamUpdate(this.editForm).then(res => {
            this.loading = false;
            this.$message.success('保存成功');
            this.checkParams();
          })
        } else {
          return false;
        }
      });
    },
    // 重置表单
    resetForm() {
      this.$refs.form.resetFields();
      this.getSysParamConfig();
    },
    // 获取可用模型列表
    getModels() {
      this.modelsLoading = true;
      sysParamModels().then(res => {
        this.modelsLoading = false;
        if (res.success) {
          this.textModels = res.data.textModels || [];
          this.vlModels = res.data.vlModels || [];
        } else {
          this.$message.error(res.message || '获取模型列表失败');
        }
      }).catch(err => {
        this.modelsLoading = false;
        this.$message.error('获取模型列表失败');
      });
    },
    // 检测系统参数
    checkParams() {
      this.checkLoading = true;
      sysParamCheck({}).then(res => {
        this.checkLoading = false;
        if (res.success) {
          this.checkResults = res.data;
        } else {
          this.$message.error(res.message || '检测失败');
        }
      }).catch(err => {
        this.checkLoading = false;
        this.$message.error('检测失败');
      });
    },
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}

.el-form-item__error {
  color: #F56C6C;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  left: 0;
  top: 100%;
}

.half-width {
  width: 40%;
}

.form-item-container {
  display: flex;
  align-items: center;
}

.check-result {
  margin-left: 20px;
}

.label-link {
  color: #409EFF;
  margin-left: 5px;
  text-decoration: none;
}

.label-link:hover {
  color: #66b1ff;
}
</style>



// WEBPACK FOOTER //
// src/views/sysParam/sysParam.vue